import { render, staticRenderFns } from "./SubmitProject.vue?vue&type=template&id=16d33276&scoped=true&"
import script from "./SubmitProject.vue?vue&type=script&lang=ts&"
export * from "./SubmitProject.vue?vue&type=script&lang=ts&"
import style0 from "./SubmitProject.vue?vue&type=style&index=0&id=16d33276&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d33276",
  null
  
)

export default component.exports